import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, UtensilsIcon, ZapIcon, CheckCircleIcon, PiggyBankIcon, CalendarIcon } from 'lucide-react';
const cards = [{
  icon: ShieldCheckIcon,
  title: 'Alimentación clara y segura',
  desc: 'Sabé exactamente qué darle sin dudas'
}, {
  icon: UtensilsIcon,
  title: 'Recetas fáciles',
  desc: 'Preparalas en minutos con ingredientes simples'
}, {
  icon: ZapIcon,
  title: 'Mejor salud y energía',
  desc: 'Notá el cambio en pocos días'
}, {
  icon: CheckCircleIcon,
  title: 'Sin errores',
  desc: 'Evitá alimentos peligrosos y errores comunes'
}, {
  icon: PiggyBankIcon,
  title: 'Ahorro de dinero',
  desc: 'Gastá menos que en alimento premium'
}, {
  icon: CalendarIcon,
  title: 'Plan listo para usar',
  desc: 'No tenés que pensar, solo seguir el plan'
}];
export function BenefitsGrid() {
  return <section className="py-20 px-4 bg-lightgreen" data-id="element-49">
      <div className="max-w-6xl mx-auto" data-id="element-50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-51">
          {cards.map((card, index) => {
          const Icon = card.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileHover={{
            y: -5
          }} className="bg-white p-8 rounded-2xl shadow-soft border border-sage flex flex-col items-center text-center group" data-id="element-52">
                <div className="w-16 h-16 rounded-full bg-sage flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300" data-id="element-53">
                  <Icon className="w-8 h-8 text-primary group-hover:text-white transition-colors duration-300" data-id="element-54" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3 font-serif" data-id="element-55">
                  {card.title}
                </h3>
                <p className="text-gray-600" data-id="element-56">{card.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}